// ══════════════════════════════════════════════════════════════════
//  Acesso à área de Clientes (Implantação)
// ══════════════════════════════════════════════════════════════════
//  Diferente de useWhatsAppEnabled e useEmpresasEnabled, que leem a flag
//  do workspace ATIVO: o grupo de Implantação é ser membro de um workspace
//  com `implantacao_console`, que quase nunca é aquele em que a pessoa está
//  trabalhando. Por isso a pergunta vai direto à RPC — é ela, e não a tela,
//  que sabe responder.
//
//  Esconder o menu é conveniência. Quem barra são as RPCs da área, que
//  conferem o grupo de novo a cada chamada.
// ══════════════════════════════════════════════════════════════════

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@hooks/useAuth';
import { currentUserIsImplantacao } from '@app/cs';

export const useImplantacaoConsole = (): { enabled: boolean; loading: boolean } => {
  const { user } = useAuth();

  const query = useQuery({
    // Por usuário, não por workspace: trocar de workspace não muda a
    // resposta, e refazer a consulta a cada troca seria ruído.
    queryKey: ['implantacaoConsole', user?.id || ''],
    queryFn: currentUserIsImplantacao,
    enabled: !!user?.id,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });

  return { enabled: query.data === true, loading: query.isLoading };
};
